import React, {
    useEffect, useMemo, useRef, useState,
} from 'react'
import i18n from 'i18next'

import HeatMap from '../HeatMap'
import VerbatimMatrix from '../VerbatimMatrix'
import SegmentSummary from '../SegmentSummary'

import './eem.scss'

const EEM = ({
    chartData, yearFilters, dashbaordStore, title, widget, segmentNameOverride,
}) => {
    const [tab, setTab] = useState('heat')
    const [segmentSummaryHeight, setSegmentSummaryHeight] = useState(0)
    const segmentSummaryRef = useRef(null)

    useEffect(() => {
        const el = segmentSummaryRef.current
        let observer
        if (el) {
            observer = new window.ResizeObserver(([entry]) => {
                setSegmentSummaryHeight(entry.borderBoxSize[0].blockSize)
            })
            observer.observe(el)
        }
        return () => observer?.disconnect()
    }, [])

    const cachedVerbatimData = useMemo(() => (
        chartData[0]?.surveyDataIds
            ? Object.keys(chartData[0]?.surveyDataIds).reduce((verbData, key) => ({
                ...verbData,
                [key]: chartData[0]?.surveyDataIds[key].reduce((cim, { companyName, ...rec }) => {
                    cim[companyName] = cim[companyName] || { count: 0, surveyDataIds: [] }
                    return {
                        ...cim,
                        [companyName]: {
                            ...cim[companyName],
                            count: cim[companyName].count + 1,
                            surveyDataIds: [...cim[companyName].surveyDataIds, rec.surveyDataId],
                        },
                    }
                }, {}),
            }), {})
            : {}
    ), chartData.surveyDataIds)

    const year = Math.max(chartData.map(({ year }) => year))

    return (
        <div
            className="EEM"
            id="eemChart"
        >
            <div ref={segmentSummaryRef}>
                <SegmentSummary
                    dashboardFilters={dashbaordStore?.dashboardFilters}
                    data={cachedVerbatimData}
                />
            </div>
            <div className="eemTabs">
                <div className={`gridTab eemTab ${tab === 'heat' ? 'active' : ''}`} onClick={() => { setTab('heat') }}>
                    <i className="fa-regular fa-grid-2" />
                    {i18n.t('dashboard.EEM.grid')}
                </div>
                <div className={`listTab eemTab ${tab !== 'heat' ? 'active' : ''}`} onClick={() => { setTab('verbMatrix') }}>
                    <i className="fa-solid fa-list" />
                    {i18n.t('dashboard.EEM.list')}
                </div>
            </div>
            {tab === 'heat'
                ? (
                    <HeatMap
                        chartData={chartData}
                        year={year}
                        dashbaordStore={dashbaordStore}
                        title={title}
                        segmentSummaryHeight={segmentSummaryHeight}
                        segmentNameOverride={segmentNameOverride}
                    />
                )
                : (
                    <VerbatimMatrix
                        chartData={[{ ...chartData[0], data: cachedVerbatimData }]}
                        year={year}
                        dashbaordStore={dashbaordStore}
                        title={title}
                        modalData={chartData[0].surveyDataIds}
                        useMatrix
                        widget={widget}
                        segmentSummaryHeight={segmentSummaryHeight}
                        segmentNameOverride={segmentNameOverride}
                    />
                )}
        </div>

    )
}

export default EEM
